<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@CreatePricingHeader">
      Bestätigungscode eingeben
    </h5>

    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="onCancelClick()"></button>
  </div>

  <div class="modal-body" style="padding: 10px;">
    <div class="mb-2">
      <label id="newpw" for="confirmationCode">Ihnen wurde ein Bestätigungscode geschickt</label>
      <input type="text" id="confirmationCode" (keydown.enter)="onConfimClick()" (input)="onInputChange($event)" #confirmationCodeInput formControlName="confirmationCode"  maxlength="6" class="form-control" placeholder="6-stelligen Bestätigungscode eingeben" />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" data-bs-dismiss="modal" i18n="@@CancelButton">Abbrechen</button>
    <button type="submit" id="confirmBtn" [disabled]="isConfirmBtnDisabled" class="btn btn-yellow" (click)="onConfimClick()" i18n="@@CancelButton">Speichern</button>
  </div>
</div>
